import React, { useRef, useState } from "react";
import { Field, Form as FinalForm } from "react-final-form";
import arrayMutators from "final-form-arrays";
import _css from "./CreateChronics.module.scss";
import { Button, Grid, GridItem, Title, Alert } from "@patternfly/react-core";
import variants from "../../../sass/colors.module.scss";
import { CREATE_CHRONIC } from "services/urls";
//import { FieldArray } from 'react-final-form-arrays';
//import { MinusIcon, PlusIcon } from "@patternfly/react-icons";
import { Editor } from '@tinymce/tinymce-react';
// @ts-ignore
import { Editor as TinyMCEEditor } from 'tinymce';


interface Props {
    onChronicCreated?: () => void;
}


const CreateChronicForm: React.FC<Props> = (props) => {

    const editorRef = React.useRef<TinyMCEEditor | null>(null);
    // const editorRef = useRef<any>(null);
    const [message, setMessage] = useState<string>("");
    const [errorMessage, setError] = useState<string | undefined>(undefined);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const onSubmit = (values, form) => {
        setIsLoading(true);
        setError(undefined); // Clear previous errors
        values.content = message;

        fetch(CREATE_CHRONIC, {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Origin": "*",
                "Credentials": "same-origin",
                "Content-Type": "application/json",
                "x-access-token": String(localStorage.getItem("x-access-token"))
            },
            mode: "cors",
            cache: "default",
            body: JSON.stringify(values)
        })
            .then(response => {
                if(response.status === 201) { // Successfully created
                    return response.json().then(data => ({ status: response.status, body: data }));
                } else {
                    // For other statuses, try to parse JSON for an error message
                    return response.json().then(errBody => Promise.reject({ status: response.status, body: errBody }));
                }
            })
            .then(({ body }) => {
                setIsLoading(false);
                form.reset(); // Reset the form fields
                setMessage(""); // Reset local state for editor content
                if(editorRef.current) {
                    editorRef.current.setContent(""); // Clear TinyMCE editor content
                }
                if(props.onChronicCreated) {
                    props.onChronicCreated(); // Call the callback to refresh parent data
                }
                // Optionally, you could set a success message here
            })
            .catch(errorInfo => {
                setIsLoading(false);
                let displayError = "Erreur lors de la création du communiqué.";
                if(errorInfo && errorInfo.body && errorInfo.body.message) {
                    displayError = errorInfo.body.message;
                } else if(errorInfo && errorInfo.message && typeof errorInfo.message === 'string') {
                    displayError = errorInfo.message;
                } else if(typeof errorInfo === 'string') {
                    displayError = errorInfo;
                }
                setError(displayError);
            });
    };

    const required = value => (value ? undefined : 'Ce champ est requis');

    const handleEditorChange = (e) => {
        setMessage(e.target.getContent())
    }

    return (
        <React.Fragment>
            <FinalForm
                onSubmit={onSubmit}
                subscription={{
                    submitting: true,
                }}
                mutators={{
                    // potentially other mutators could be merged here
                    ...arrayMutators
                }}
                validate={values => {
                    const errors: { title?: string; resume?: string } = {};
                    if(!values.title) {
                        errors.title = "Le titre est requis";
                    }
                    if(!values.resume) {
                        errors.resume = "Le résumé est requis";
                    }
                    // Basic validation for editor content
                    if(!message || message.trim() === "" || message.trim() === "<p></p>") {
                        // errors["content"] = "Le contenu est requis"; // This won't show directly, but good for logic
                    }
                    return errors;
                }}
            >
                {({ handleSubmit, form }) => ( // Added form here to potentially use form.getState() for validation display
                    <form onSubmit={handleSubmit} className={_css.container}>
                        <Grid hasGutter>
                            <GridItem>
                                <Title headingLevel={"h1"} className={_css.title}>
                                    Créer une nouvelle chronique.
                                </Title><br />
                                <Grid hasGutter className={_css.form_components}>
                                    <GridItem lg={12}>
                                        <Field
                                            name="title"
                                            validate={required}
                                            subscription={{
                                                value: true,
                                                active: true,
                                                error: true,
                                                touched: true
                                            }}
                                        >
                                            {({ input, meta }) => (
                                                <label htmlFor="title">
                                                    <input
                                                        className={[
                                                            _css.input,
                                                            (meta.error && meta.touched) && variants.error_input
                                                        ].join(" ")}
                                                        type="text"
                                                        id="title"
                                                        onBlur={input.onBlur}
                                                        value={input.value}
                                                        onChange={input.onChange}
                                                        name={input.name}
                                                        placeholder={"Titre de la nouvelle"}
                                                    />
                                                </label>
                                            )}
                                        </Field>
                                    </GridItem>
                                    <GridItem lg={12}>
                                        <Field
                                            name="resume"
                                            validate={required}
                                            subscription={{
                                                value: true,
                                                active: true,
                                                error: true,
                                                touched: true
                                            }}
                                        >
                                            {({ input, meta }) => (
                                                <label htmlFor="resume">
                                                    <input
                                                        className={[
                                                            _css.input,
                                                            (meta.error && meta.touched) && variants.error_input
                                                        ].join(" ")}
                                                        type="text"
                                                        id="resume"
                                                        value={input.value}
                                                        onBlur={input.onBlur}
                                                        onChange={input.onChange}
                                                        name={input.name}
                                                        placeholder={"Resume de la nouvelle"}
                                                    />
                                                </label>
                                            )}
                                        </Field>
                                    </GridItem>
                                </Grid>
                            </GridItem>
                            <GridItem>
                                <Editor
                                    initialValue=""
                                    tinymceScriptSrc="/tinymce/tinymce.min.js"
                                    // apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
                                    init={{
                                        license_key: 'gpl',
                                        plugins: 'advlist autolink lists link image',
                                        toolbar: `undo redo | formatselect | bold italic | alignleft aligncenter alignright | bullist numlist outdent indent | help | image`,
                                        image_title: true,
                                        height: 400,
                                        automatic_uploads: true,
                                        file_picker_types: 'image',
                                        file_picker_callback: function(cb, value, meta) {
                                            const input = document.createElement('input');
                                            input.setAttribute('type', 'file');
                                            input.setAttribute('accept', 'image/*');
                                            input.onchange = function() {
                                                // @ts-ignore
                                                const file = this.files[0];
                                                const reader = new FileReader();
                                                reader.onload = function() {
                                                    const id = 'blobid' + (new Date()).getTime();
                                                    // @ts-ignore
                                                    const blobCache = tinymce.activeEditor.editorUpload.blobCache;
                                                    // @ts-ignore
                                                    const base64 = reader.result.split(',')[1];
                                                    const blobInfo = blobCache.create(id, file, base64);
                                                    blobCache.add(blobInfo);
                                                    cb(blobInfo.blobUri(), { title: file.name });
                                                };
                                                reader.readAsDataURL(file);
                                            };
                                            input.click();
                                        },
                                        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                                    }}
                                    onChange={handleEditorChange}
                                />
                            </GridItem>
                            <GridItem>
                                {errorMessage &&
                                    <Alert variant="danger" isInline title="Erreur lors de la création du communiqué." />
                                }
                            </GridItem>
                            <GridItem>
                                <Button isDisabled={isLoading} type={"submit"} isLoading={isLoading}>Créer</Button>
                            </GridItem>
                        </Grid>
                    </form>
                )}
            </FinalForm>
        </React.Fragment>
    )
}

export { CreateChronicForm }
